import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './UserAgreement.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class UserAgreement extends Component {

    render() {
		return (
			<div className="showtix-section container">
				<div className="row">
					<div className="col-12">
						<h1 id="sr-title">{strings.title}</h1>
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-lg-8">
						{ReactHtmlParser(strings.content)}
					</div>
				</div>
			</div>
		);
  	}
}

export default UserAgreement;



// WEBPACK FOOTER //
// ./src/components/UserAgreement/UserAgreement.js